const lang = {
  en: {
    search: "Search",
    gptSearchPlaceholder: "What would you like to watch today?",
  },
  tamil: {
    search: "தேடல்",
    gptSearchPlaceholder: "இன்று நீங்கள் எதைப் பார்க்க விரும்புகிறீர்கள்?",
  },
  hindi: {
    search: "खोज",
    gptSearchPlaceholder: "आज आप क्या देखना चाहेंगे?",
  },
  japanese: {
    search: "検索",
    gptSearchPlaceholder: "今日は何を見たいですか？",
  },
};
export default lang;
